import { render, staticRenderFns } from "./nonEmptyCart.vue?vue&type=template&id=0208bb15&scoped=true&"
import script from "./nonEmptyCart.vue?vue&type=script&lang=js&"
export * from "./nonEmptyCart.vue?vue&type=script&lang=js&"
import style0 from "./nonEmptyCart.vue?vue&type=style&index=0&id=0208bb15&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0208bb15",
  null
  
)

export default component.exports